/**
 * @file select2
 */
'use strict';
import { select2 } from '../../Libs/select2.min'

/**
 * @classname FormSelect2
 * @classdesc select2
 */
export default class Select2 {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 * @param {instance} controller - controller オブジェクト
	 */
	constructor($e, controller) {
		console.log('Select2.constructor');
		this._$e = $e;
		this._controller = controller;
		if($e.hasClass('co_author')){
			console.log('co_author');
			$e.select2({
				placeholder: '社員名で検索'
			});
			$e.on('select2:open', () => {
				$('.select2-search.select2-search--dropdown input').focus().select();
			});
		}else{
			$e.select2();
			this.addHasAlertClassToChoices();
			this.addLinkButtonToChoices()
			$e.on('select2:select', () => {
				this.addHasAlertClassToChoices()
				this.addLinkButtonToChoices()
			});
			$e.on('select2:unselect', () => {
				this.addHasAlertClassToChoices()
				this.addLinkButtonToChoices()
			});
			$e.on('select2:open', () => {
				this.addHasAlertClassToOptions();
			});
		}
		$('.btn-select2-clear').on('click', () => {
			$e.val('').trigger('change');
		});
		controller.on('resetSelect2', () => this.resetSelect2());
	};


	/**
	 * select2再起動
	 *
	 * @memberof Select2
	 * @return {string} options - select option
	 */
	resetSelect2() {
		console.log(`Select2.resetSelect2`);
		this._$e.select2('destroy').select2();
	}


	addHasAlertClassToChoices() {
		console.log('Select2.addCustomClasses')

		// DOM反映後に実行するためsetTimeoutで非同期にする
		setTimeout(() => {
			$('.select2-selection__choice').each((_, element) => {
				const $target = $(element);
				const title = $target.attr('title'); 
				const $option = this._$e.find('option').filter((_, e) => $(e).text() === title);
		
				if ($option.data('has-alert')) $target.addClass('has-alert');
			});
		}, 0)
	}


	addHasAlertClassToOptions() {
		console.log('Select2.addHasAlertClassToOptions')

		// DOM反映後に実行するためsetTimeoutで非同期にする
		setTimeout(() => {
			$('.select2-results__option').each((_, element) => {
				const $target = $(element);
				const text = $target.text();
				const $option = this._$e.find('option').filter((_, e) => $(e).text() === text);
		
				if ($option.data('has-alert')) $target.addClass('has-alert');
			});
		}, 0)
	}


	addLinkButtonToChoices() {
		console.log('Select2.addLinkButtonToChoices')

		// DOM反映後に実行するためsetTimeoutで非同期にする
		setTimeout(() => {
			$('.select2-selection__choice').each((_, element) => {
				const $target = $(element);
				if ($target.find('.external-link-button').length) return
				
				const title = $target.attr('title'); 
				const $option = this._$e.find('option').filter((_, e) => $(e).text() === title);
				const href = $option.data('href');

				if (!href) return

				$target.append(`
					<button type="button" class="external-link-button">
						<i class="fas fa-external-link-alt d-block"></i>
					</button>
				`);

				$target.find('.external-link-button').css({
					'background-color': 'inherit',
					'color': 'inherit',
					'border': 'none',
				});

				$target.find('i').css({
					'color': 'inherit',
					'font-size': '10px',
				});

				$target.find('button').on('click', (e) => {
					e.preventDefault()
					e.stopPropagation()
					window.open(href, '_blank')
				})
			});
		}, 0)
	}
}
